// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 fill=%27none%27><path d=%27M3 4.5L6 7.5L9 4.5%27 stroke=%27%23808080%27 stroke-width=%271.25%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Read-only derived value (Competencia) ────────────────── */
.nc-fixed {
  font-size: var(--fs-ui);
  color: var(--text-secondary);
  padding: 8px 0;
}

/* ─── Rol / Año row ─────────────────────────────────────────── */
.nc-rol-row {
  display: flex;
  gap: 10px;
}

/* ─── Cod field: muted "cod N" prefix (like the phone "+56") + a borderless
   native <select> carrying the name. The box owns the border + chevron. ── */
.nc-codfield {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border);
  background: var(--bg-alt);
  padding: 7px 10px;
  border-radius: var(--radius-1);
  font-size: var(--fs-2xs);
  color: var(--text);
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}
.nc-codfield:focus-within {
  border-color: var(--signal);
  box-shadow: var(--focus-ring);
}
.nc-codfield.input-error {
  border-color: var(--danger);
  box-shadow: var(--focus-ring-err);
}
.nc-codfield.is-disabled {
  background: var(--bg);
  cursor: not-allowed;
}
/* Chevron only on interactive (non-disabled) fields. */
.nc-codfield:not(.is-disabled) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px 12px;
}

/* The muted, slightly smaller cod — same tone/role as \`.phone-input__cc\`. */
.nc-codfield__cod {
  flex-shrink: 0;
  white-space: nowrap;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  user-select: none;
}

.nc-codfield__select {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
  padding-right: 18px; /* clear the box chevron */
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}
.nc-codfield__select:disabled {
  cursor: not-allowed;
  color: var(--text-secondary);
}

/* ─── Clear-form control (left of the CTA bar) ─────────────────── */
.nc-clear {
  margin-right: auto; /* push it left while the CTAs stay right */
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--text-muted);
  font-size: var(--fs-meta);
  padding: 6px 4px;
  border-radius: var(--radius-1);
  transition:
    color 120ms ease,
    background 120ms ease;
}
.nc-clear:hover:not(:disabled) {
  color: var(--text);
  background: var(--bg);
}
.nc-clear:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.nc-clear svg {
  width: 14px;
  height: 14px;
}

/* ─── Error state on selects / inputs ──────────────────────── */
.form-input.input-error {
  border-color: var(--danger);
  box-shadow: var(--focus-ring-err);
}

/* ─── CTA bar ────────────────────────────────────────────────── */
.nc-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

/* Subscription error block: the message and, below it, its ways out. */
.nc-error__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/causas/NuevaCausaForm.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,SAAS;AACX;;AAEA;6EAC6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB;;yBAEuB;AACzB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA,uDAAuD;AACvD;EACE,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,mBAAmB,EAAE,0BAA0B;EAC/C,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B;;yBAEuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB","sourcesContent":["/* ─── Read-only derived value (Competencia) ────────────────── */\n.nc-fixed {\n  font-size: var(--fs-ui);\n  color: var(--text-secondary);\n  padding: 8px 0;\n}\n\n/* ─── Rol / Año row ─────────────────────────────────────────── */\n.nc-rol-row {\n  display: flex;\n  gap: 10px;\n}\n\n/* ─── Cod field: muted \"cod N\" prefix (like the phone \"+56\") + a borderless\n   native <select> carrying the name. The box owns the border + chevron. ── */\n.nc-codfield {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--border);\n  background: var(--bg-alt);\n  padding: 7px 10px;\n  border-radius: var(--radius-1);\n  font-size: var(--fs-2xs);\n  color: var(--text);\n  transition:\n    border-color 120ms ease,\n    box-shadow 120ms ease;\n}\n.nc-codfield:focus-within {\n  border-color: var(--signal);\n  box-shadow: var(--focus-ring);\n}\n.nc-codfield.input-error {\n  border-color: var(--danger);\n  box-shadow: var(--focus-ring-err);\n}\n.nc-codfield.is-disabled {\n  background: var(--bg);\n  cursor: not-allowed;\n}\n/* Chevron only on interactive (non-disabled) fields. */\n.nc-codfield:not(.is-disabled) {\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'><path d='M3 4.5L6 7.5L9 4.5' stroke='%23808080' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px 12px;\n}\n\n/* The muted, slightly smaller cod — same tone/role as `.phone-input__cc`. */\n.nc-codfield__cod {\n  flex-shrink: 0;\n  white-space: nowrap;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  user-select: none;\n}\n\n.nc-codfield__select {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  padding: 0;\n  padding-right: 18px; /* clear the box chevron */\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n}\n.nc-codfield__select:disabled {\n  cursor: not-allowed;\n  color: var(--text-secondary);\n}\n\n/* ─── Clear-form control (left of the CTA bar) ─────────────────── */\n.nc-clear {\n  margin-right: auto; /* push it left while the CTAs stay right */\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-muted);\n  font-size: var(--fs-meta);\n  padding: 6px 4px;\n  border-radius: var(--radius-1);\n  transition:\n    color 120ms ease,\n    background 120ms ease;\n}\n.nc-clear:hover:not(:disabled) {\n  color: var(--text);\n  background: var(--bg);\n}\n.nc-clear:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.nc-clear svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* ─── Error state on selects / inputs ──────────────────────── */\n.form-input.input-error {\n  border-color: var(--danger);\n  box-shadow: var(--focus-ring-err);\n}\n\n/* ─── CTA bar ────────────────────────────────────────────────── */\n.nc-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n/* Subscription error block: the message and, below it, its ways out. */\n.nc-error__links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
